import { useRef, useEffect, useCallback, PropsWithChildren, FC, useState } from 'react'
import { Spin, Select, DatePicker } from 'antd'
import CardContainer from '@/pages/Bmjy/components/components/CardContainer'
import DualAxes from '@/pages/Bmjy/components/components/DualAxes'
import { Column } from '@antv/g2plot';

const tabsOptions = [
  {
    label: '按院', 
    value: 'ay',
    api: null
  }, 
  {
    label: '按所', 
    value: 'as',
    api: null
  }
]

const gsTypeFilterOptions = [
  {
    label: '项目', 
    value: '项目',
  }, 
  {
    label: '非项目', 
    value: '非项目',
  }, 
]

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const Component: PropType = ({updateTime}) => {
  const [loading, setLoading] = useState(false)
  const containerRef = useRef()
  const globalRef = useRef({
    params: {
      tab: '',
      depart: ''
    },
    column: null as Column,
    loadTime: updateTime
  })

  const renderChart = useCallback((data1) => {
    if(!globalRef.current.column) {
      return
    }
    globalRef.current.column.changeData([...data1.map(r => ({
      label: r.label,
      value: r.jn,
      zb: r.zb,
      type: '本年开票收入(万)'
    })), ...data1.map(r => ({
      label: r.label,
      value: r.qn,
      zb: r.zb,
      type: '上年开票收入(万)'
    }))])
  }, [])

  const mockData = useCallback(() => {
    const data1 = []
    for(let i=0; i<12; i++) {
      data1.push({
        "label": i+ 1 + "所",
        "jn": Math.floor(Math.random()*100),
        qn: Math.floor(Math.random()*100),
        zb: Math.floor(Math.random()*100)
      })
    }
    renderChart(data1)
    // setBnData(data1)
    // setSnData(data2)
    // setZbData(data3)
  }, [renderChart])
  
  // 获取图表数据
  const getColumnData = useCallback(async () => {
    const tabOption = tabsOptions.find(t => t.value === globalRef.current.params.tab)
    setTimeout(() => {
      mockData()
    }, 1000)
    if(!tabOption || !tabOption.api) {
      return
    }

    const res = await tabOption.api()
    if(res.success) {
      
    }
  }, [mockData])

  // 获取接口数据
  const getList = useCallback(async () => {
    setLoading(true)
    Promise.all([getColumnData()]).finally(() => {
      setLoading(false)
    })
  }, [getColumnData])

  // 变更类型
  const handleTabChange = useCallback((value) => {
    globalRef.current.params = value
    getList()
  }, [getList])

  useEffect(() => {
    if(globalRef.current.loadTime !== updateTime) {
      globalRef.current.loadTime = updateTime
      getList()
    }
  }, [updateTime, getList])

  useEffect(() => {
    globalRef.current.column = new Column(containerRef.current, {
      data: [],
      xField: 'label',
      yField: 'value',
      seriesField: 'type',
      isGroup: true,
      legend: {
        position: 'bottom',
      },
      tooltip: {
        customContent(title, items) {
          console.log(title, items)
          if(!items) {
            return ''
          }
          const list = [...items, {
            color: '#506377',
            name: '本年占比去年开票收入总数(%)',
            value: items[0] && items[0].data.zb || ''
          }]
          return `<div>
            <div class="g2-tooltip-title">${title}</div>
            <ul class="g2-tooltip-list">
              ${
                list.map(item => `
                  <li class="g2-tooltip-list-item">
                    <span class="g2-tooltip-marker" style="background: ${item.color}"></span>
                    <span class="g2-tooltip-name">${item.name}</span>
                    <span class="g2-tooltip-value">${item.value}</span>
                  </li>
                `).join('')
              }
            </ul>
          </div>`
        }
      },
      columnStyle: {
      },
      yAxis: {
        label: {
          formatter: (text) => {
            return text + '万'
          }
        }
      }
    });

    globalRef.current.column.render();
  }, [])

  return (
    <Spin spinning={loading} wrapperClassName='full-spin'>
      <CardContainer
        tabs={tabsOptions}
        onTabChange={handleTabChange}
        title='各部门年度统计'
        customFilter={
          <>
            <div className='ml-10'>
              <Select placeholder="请选择" size='small' allowClear>
                {
                  gsTypeFilterOptions.map(r => <Select.Option value={r.value} key={r.value}>{r.label}</Select.Option>)
                }
              </Select>
            </div>
            <div className='ml-10'>
              <DatePicker.RangePicker className='ml-10' size='small'></DatePicker.RangePicker>
            </div>
          </>
        }
      >
        <div className='h-full pt-20'>
          <div ref={containerRef} className='h-full'></div>
          {/* <DualAxes
            bar1Label="本年开票收入(万)"
            bar1Data={bnData}
            bar2Label='上年开票收入(万)'
            bar2Data={snData}
            lineLabel='本年占比去年开票收入总数(%)'
            lineData={zbData}
          /> */}
        </div>
      </CardContainer>
    </Spin>
  )
}

export default Component
